import { PDFViewer } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { BoxScoreReport } from "./BoxScoreReport";
import { APP_API_URL } from "./Environment";
import FrenchBoxScoreReport from "./FrenchReport";
import { PlayByPlayReport } from "./PlayByPlayReport";
import { PlayByPlayReportFull } from "./PlayByPlayReportFull";
import { QuarterScoresReport } from "./QuarterScoresReport";
import { ScoresheetReport } from "./ScoresheetReport";
import loading from "./assets/loading.svg";
import HockeyMatchReport from "./hockey/HockeyMatchReport";
import HockeyCardsReport from "./hockey/HockeyCardsReport";
import ShootoutReport from "./hockey/ShootoutReport/ShootoutReport.jsx";

const defaultFixtureProfileConfigs = {
  basketball: {
    maxFoulsPersonal: 5,
    efficiencyType: "EFFICIENCY",
  },
  hockey: {
    periodLength: 15,
  },
};

const ensureFixtureProfileDetails = (reportsData, sport) => {
  const existingFixtureProfile =
    reportsData?.data?.fixtureProfile?.profile ?? {};
  const newFixtureProfile = {
    ...defaultFixtureProfileConfigs[sport],
    ...existingFixtureProfile,
  };
  const newReportsData = { ...reportsData };
  if (!newReportsData.data.fixtureProfile)
    newReportsData.data.fixtureProfile = {};
  if (!newReportsData.data.fixtureProfile.profile)
    newReportsData.data.fixtureProfile.profile = {};
  newReportsData.data.fixtureProfile.profile = newFixtureProfile;
  return newReportsData;
};

function Reports(props) {
  const { reportType, orgId, token } = props;
  const [reportData, setReportData] = useState({});

  // TODO: This sport recognition should be done in a better way
  const sport =
    reportType === "hockeyMatch" || reportType === "hockeyCards" || reportType === "shootout"
      ? "hockey"
      : "basketball";

  /*
   * API URL loaded from configuration
   * */
  const apiUrlPrefix = `${APP_API_URL}/v1/`;

  /*
   * load data on report load
   * */
  useEffect(() => {
    const getData = async () => {
      const reportToApi = {
        boxscore: "fibaBoxScore",
        boxscorePerPeriod: "boxScoreWithPeriods",
        advancedBoxscore: "boxScoreWithPeriods", // this one has necessary totals for the summary
        scoresheet: "scoresheet",
        quarterscore: "scoringPbp",
        playbyplay: "scoringPbp",
        playbyplayfull: "fullPbp",
        hockeyMatch: "fullPbp",
        hockeyCards: "fullPbp",
        shootout: "fullPbp",
      };

      const apiUrlReport = `${apiUrlPrefix}${sport}/organizations/${orgId}/reports?token=${token}&reportType=${reportToApi[reportType]}`;
      return await fetch(apiUrlReport).then((response) => response.json());
    };

    if (apiUrlPrefix && token && orgId) {
      getData().then((result) => {
        setReportData(result);
      });
    } else {
      return <LoadingMessage />;
    }
  }, [reportType, apiUrlPrefix, token, orgId]);

  /*
   * Generate report after the data is loaded
   * */
  if (!reportData || !reportData.data) {
    return <LoadingMessage />;
  } else {
    const finalReportData = ensureFixtureProfileDetails(reportData, sport);
    return (
      <PDFViewer className="pdf-viewer">
        {reportType === "scoresheet" && (
          <ScoresheetReport {...{ ...props, ...finalReportData }} />
        )}
        {reportType === "boxscore" && (
          <BoxScoreReport {...{ ...props, ...finalReportData }} />
        )}
        {reportType === "boxscorePerPeriod" && (
          <BoxScoreReport {...{ ...props, ...finalReportData }} />
        )}
        {reportType === "advancedBoxscore" && (
          <FrenchBoxScoreReport {...{ ...props, ...finalReportData }} />
        )}
        {/* {reportType === "boxscorefr" && (
          <BoxScoreReportFr {...{ ...props, ...finalReportData }} />
        )} */}
        {reportType === "playbyplay" && (
          <PlayByPlayReport {...{ ...props, ...finalReportData }} />
        )}
        {reportType === "playbyplayfull" && (
          <PlayByPlayReportFull {...{ ...props, ...finalReportData }} />
        )}
        {/* {reportType === "shotchart" && (
          <ShotChartReport {...{ ...props, ...finalReportData }} />
        )} */}
        {reportType === "quarterscore" && (
          <QuarterScoresReport {...{ ...props, ...finalReportData }} />
        )}
        {reportType === "hockeyMatch" && (
          <HockeyMatchReport {...{ ...props, ...finalReportData }} />
        )}
        {reportType === "hockeyCards" && (
          <HockeyCardsReport {...{ ...props, ...finalReportData }} />
        )}
        {reportType === "shootout" && (
          <ShootoutReport {...{ ...props, ...finalReportData }} />
        )}
      </PDFViewer>
    );
  }
}

export const ReportsIntl = injectIntl(Reports);

const LoadingMessage = () => {
  return (
    <div className={"loading-data"}>
      <img alt="Loading" src={loading} />
    </div>
  );
};
